export const ACCOUNT_DETAILS_TITLE = 'PrimoProfile/AccountDetails';
export const ACCOUNT_DETAILS_SUCCESS_TITLE =
  'PrimoProfile/AccountDetailsSuccess';
export const EDIT_PASSWORD = 'PrimoProfile/EditPassword';
export const EDIT_ACCOUNT_NAME = 'PrimoProfile/EditAccountName';
export const EDIT_EMAIL_ADDRESS = 'PrimoProfile/EditEmailAddress';
export const ADD_NEW_ACCOUNT_LOGIN = 'PrimoProfile/ADD_NEW_ACCOUNT_LOGIN';
